var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInventory(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 3.7C6.4 5.19117 5.19117 6.4 3.7 6.4C2.20883 6.4 1 5.19117 1 3.7C1 2.20883 2.20883 1 3.7 1C5.19117 1 6.4 2.20883 6.4 3.7Z",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.7C19 5.19117 17.7912 6.4 16.3 6.4C14.8088 6.4 13.6 5.19117 13.6 3.7C13.6 2.20883 14.8088 1 16.3 1C17.7912 1 19 2.20883 19 3.7Z",
    stroke: "white",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 16.3C6.4 17.7911 5.19117 19 3.7 19C2.20883 19 1 17.7911 1 16.3C1 14.8088 2.20883 13.6 3.7 13.6C5.19117 13.6 6.4 14.8088 6.4 16.3Z",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19 16.3C19 17.7911 17.7912 19 16.3 19C14.8088 19 13.6 17.7911 13.6 16.3C13.6 14.8088 14.8088 13.6 16.3 13.6C17.7912 13.6 19 14.8088 19 16.3Z",
    stroke: "white",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 16.3H13.6",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.4 3.70001H13.6",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3 13.6L16.3 6.39998",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.7 13.6L3.7 6.39998",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/Inventory.3910c8df1baff637d1a4e0b371481a3d.svg";
export { ForwardRef as ReactComponent };